import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface HelpState {
  isModalOpen: boolean;
  currentTopicId: string | null;
  searchQuery: string;
  recentTopics: string[];

  // Actions
  openModal: (topicId?: string) => void;
  closeModal: () => void;
  setCurrentTopic: (topicId: string) => void;
  setSearchQuery: (query: string) => void;
  addRecentTopic: (topicId: string) => void;
}

/**
 * ヘルプシステムの状態管理
 *
 * 機能:
 * - モーダル表示状態
 * - 現在のトピック
 * - 検索クエリ
 * - 最近閲覧したトピック（最大5件、localStorageに永続化）
 */
export const useHelpStore = create<HelpState>()(
  persist(
    (set, get) => ({
      isModalOpen: false,
      currentTopicId: null,
      searchQuery: '',
      recentTopics: [],

      openModal: (topicId) =>
        set({
          isModalOpen: true,
          currentTopicId: topicId || get().currentTopicId,
        }),

      closeModal: () =>
        set({
          isModalOpen: false,
          searchQuery: '', // 検索クエリもクリア
        }),

      setCurrentTopic: (topicId) => {
        set({ currentTopicId: topicId });
        get().addRecentTopic(topicId);
      },

      setSearchQuery: (query) => set({ searchQuery: query }),

      addRecentTopic: (topicId) =>
        set((state) => ({
          recentTopics: [
            topicId,
            ...state.recentTopics.filter((id) => id !== topicId),
          ].slice(0, 5), // 最大5件まで
        })),
    }),
    {
      name: 'help-storage', // localStorageのキー名
      partialize: (state) => ({
        recentTopics: state.recentTopics, // 最近閲覧履歴のみ永続化
      }),
    }
  )
);
